import { useCurrentWorkspacePermissionsContext } from '~/providers/CurrentWorkspacePermissionsProvider';
import { visibleCustomFieldsLengthSelector } from '~/store/configViews/selectors';
import { canSeeCustomFields } from '~/utils/permissions/workspacePermissions';
import { useAirSelector } from '~/utils/ReduxUtils';

export const usePermissionedVisibleCustomFieldsLength = () => {
  const { data: permissions } = useCurrentWorkspacePermissionsContext();
  const canViewCustomFields = canSeeCustomFields(permissions);

  const visibleCustomFieldsLength = useAirSelector(visibleCustomFieldsLengthSelector);
  const permissionedVisibleCustomFieldsLength = canViewCustomFields ? visibleCustomFieldsLength : 0;

  return { permissionedVisibleCustomFieldsLength };
};
